<template>
  <div class="background-container">
    <div class="wave"></div>
    <div class="wave"></div>
    <div class="wave"></div>
  </div>

  <div class="wrapper">
    <!-- Hinzufügen Modal -->
    <div
      class="modal fade"
      id="add-modal"
      tabindex="-1"
      aria-labelledby="add-modal-title"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen-md-down modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="add-modal-title">
              <span class="d-flex">
                <span
                  class="material-symbols-outlined d-flex align-self-center me-2"
                  >add</span
                >
                <span>Hinzufügen</span>
              </span>
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="my-2">
              <label for="new-video-titel" class="form-label">Titel</label>
              <input
                id="new-video-titel"
                type="text"
                class="form-control"
                v-model="newVideo.titel"
              />
            </div>

            <div class="my-2">
              <label for="new-video-url" class="form-label">URL</label>
              <input
                id="new-video-url"
                type="text"
                class="form-control"
                v-model="newVideo.url"
              />
            </div>

            <div class="my-2">
              <label for="new-video-dauer" class="form-label">Videodauer</label>
              <input
                id="new-video-dauer"
                type="text"
                class="form-control"
                v-model="newVideo.dauer"
              />
            </div>

            <div class="my-2">
              <label for="new-video-trainingsmethode" class="form-label"
                >Modus</label
              >
              <select
                id="new-video-trainingsmethode"
                class="form-select"
                aria-label="Default select example"
                v-model="newVideo.trainingsmethode"
              >
                <option :value="null" selected>
                  Wähle eine Trainingsmethode
                </option>
                <option value="laufen">Laufen</option>
                <option value="fahrradfahren">Fahrradfahren</option>
                <option value="rudern">Rudern</option>
              </select>
            </div>

            <div class="my-2">
              <label for="new-video-tag" class="form-label"
                >Tag eingeben oder auswählen</label
              >
              <div class="input-group">
                <!-- Eingabefeld -->
                <input
                  id="new-video-tag"
                  class="form-control"
                  style="min-width: 12rem"
                  list="tagsList"
                  v-model="newVideo.tag"
                  placeholder="Tag eingeben oder auswählen"
                />

                <!-- X-Button zum Löschen -->
                <button
                  class="btn btn-danger"
                  style="height: 38px"
                  type="button"
                  @click="newVideo.tag = null"
                  v-if="newVideo.tag"
                >
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </div>

              <!-- Datalist -->
              <datalist id="tagsList">
                <option v-for="tag in knownTags" :key="tag" :value="tag">
                  {{ tag }}
                </option>
              </datalist>
            </div>

            <div class="my-2">
              <label for="settings-base-speed" class="col-form-label"
                >Geschwindigkeit im Video (ca.):</label
              >
              <div class="input-group">
                <input
                  id="settings-base-speed"
                  type="number"
                  step="1"
                  min="1"
                  max="200"
                  class="form-control"
                  v-model="newVideo.baseSpeedInKmH"
                />
                <span class="input-group-text" id="settings-base-speed-addon"
                  >km/h</span
                >
              </div>
            </div>

            <div class="my-2">
              <label for="new-video-videobeginn" class="form-label"
                >Videobeginn</label
              >
              <input
                id="new-video-videobeginn"
                type="text"
                class="form-control"
                v-model="newVideo.videobeginn"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success"
              @click="speichern"
            >
              <span class="d-flex align-self-center">
                <span class="material-symbols-outlined me-2">check</span>
                Hinzufügen
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-4">
      <div class="row mb-4">
        <div class="col-12">
          <div class="card">
            <div class="card-body pb-md-3" style="padding-bottom: 4rem">
              <div class="row d-flex align-items-center">
                <div
                  class="col-12 col-md-12 col-lg-6 text-center text-lg-start"
                >
                  <h1 class="text-ruderclub-orange">Videotraining</h1>
                </div>

                <div
                  class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end"
                >
                  <!-- Filter Buttons -->
                  <div class="btn-group">
                    <div class="me-2" style="margin-top: 0.2rem">
                      <div class="input-group">
                        <!-- Eingabefeld -->
                        <input
                          id="tagInput"
                          class="form-control"
                          style="min-width: 12rem"
                          list="tagsList"
                          v-model="filterTag"
                          placeholder="Tag eingeben oder auswählen"
                        />

                        <!-- X-Button zum Löschen -->
                        <button
                          class="btn btn-danger"
                          style="height: 38px"
                          type="button"
                          @click="filterTag = null"
                          v-if="filterTag"
                        >
                          <span class="material-symbols-outlined">delete</span>
                        </button>
                      </div>

                      <!-- Datalist -->
                      <datalist id="tagsList">
                        <option
                          v-for="tag in knownTags"
                          :key="tag"
                          :value="tag"
                        >
                          {{ tag }}
                        </option>
                      </datalist>
                    </div>
                    <div class="pills ms-4 ms-md-0 mt-5 mt-md-0">
                      <button
                        class="btn badge rounded-pill me-2"
                        :class="
                          filterTrainingsmethoden === 'laufen'
                            ? 'bg-warning border-dark'
                            : 'bg-outline-warning'
                        "
                        @click="toggleFilter('laufen')"
                      >
                        <span
                          class="material-symbols-outlined"
                          :class="{
                            'text-dark': filterTrainingsmethoden === 'laufen',
                          }"
                          >directions_run</span
                        >
                      </button>
                      <button
                        class="btn badge rounded-pill me-2"
                        :class="
                          filterTrainingsmethoden === 'fahrradfahren'
                            ? 'bg-success border-dark'
                            : 'bg-outline-success'
                        "
                        @click="toggleFilter('fahrradfahren')"
                      >
                        <span
                          class="material-symbols-outlined"
                          :class="{
                            'text-dark':
                              filterTrainingsmethoden === 'fahrradfahren',
                          }"
                          >directions_bike</span
                        >
                      </button>
                      <button
                        class="btn badge rounded-pill me-2"
                        :class="
                          filterTrainingsmethoden === 'rudern'
                            ? 'bg-info border-dark'
                            : 'bg-outline-info'
                        "
                        @click="toggleFilter('rudern')"
                      >
                        <span
                          class="material-symbols-outlined"
                          :class="{
                            'text-dark': filterTrainingsmethoden === 'rudern',
                          }"
                          >rowing</span
                        >
                      </button>

                      <!-- Sort Button -->
                      <button
                        class="btn badge rounded-pill bg-secondary"
                        :class="{ 'border-dark': sortOrder !== 0 }"
                        @click="toggleSort"
                      >
                        <span
                          class="material-symbols-outlined"
                          :class="{ 'text-dark': sortOrder !== 0 }"
                        >
                          {{
                            sortOrder === 1
                              ? "arrow_upward"
                              : sortOrder === -1
                              ? "arrow_downward"
                              : "swap_vert"
                          }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="filteredAndSortedVideos.length === 0" class="col-12">
          <div class="alert alert-info">
            Es wurden noch keine Videos mit den angegebenen Filtern hinterlegt.
          </div>
        </div>

        <!-- HINZUFÜGEN -->
        <div v-if="istAdmin" class="col-12 col-md-6 col-lg-3">
          <div
            class="video-card card bg-dark text-light border-dark shadow-sm mb-4 pb-4"
            @click="showHinzufuegenModal"
          >
            <span
              style="position: absolute; margin-top: 0.2rem; left: 0.2rem"
              class="badge rounded-pill bg-light text-dark"
            >
              <span class="material-symbols-outlined">edit_road</span>
            </span>

            <span
              style="position: absolute; margin-top: 0.2rem; right: 0.2rem"
              class="badge rounded-pill bg-primary"
            >
              {{ newVideo.dauer }}
            </span>

            <span
              class="d-flex align-self-center material-symbols-outlined icon-large"
              >add</span
            >
            <div class="card-body">
              <h5 class="video-card-title card-title" title="Hinzufügen">
                {{ newVideo.titel ?? "Neues Video hinzufügen" }}
              </h5>

              <span
                v-if="newVideo.tag"
                style="position: absolute; bottom: 0.4rem; right: 0.2rem"
                class="badge rounded-pill bg-light text-dark"
              >
                {{ newVideo.tag }}
              </span>
            </div>
          </div>
        </div>

        <!-- YOUTUBE -->
        <div v-if="filterTrainingsmethode" class="col-12 col-md-6 col-lg-3">
          <div
            class="video-card card bg-dark text-light border-dark shadow-sm mb-4 pb-4"
            @click="oeffneYoutubeSuche"
          >
            <span
              style="position: absolute; margin-top: 0.2rem; left: 0.2rem"
              class="badge rounded-pill text-dark"
              :class="
                filterTrainingsmethode === 'rudern'
                  ? 'bg-info'
                  : filterTrainingsmethode === 'laufen'
                  ? 'bg-warning'
                  : 'bg-success'
              "
            >
              <TrainingsmethodeIconComponent
                :trainingsmethode-id="filterTrainingsmethode"
              ></TrainingsmethodeIconComponent>
            </span>

            <span
              class="d-flex align-self-center material-symbols-outlined icon-large"
              >youtube_activity</span
            >
            <div class="card-body">
              <h5 class="video-card-title card-title" title="Hinzufügen">
                Video auf Youtube finden
              </h5>

              <span
                style="position: absolute; bottom: 0.4rem; right: 0.2rem"
                class="badge rounded-pill bg-light text-dark"
              >
                {{ filterTag ? filterTag : "Youtube" }}
              </span>
            </div>
          </div>
        </div>

        <!-- LISTE -->
        <div
          v-for="(video, index) in filteredAndSortedVideos"
          :key="index"
          class="col-12 col-md-6 col-lg-3"
        >
          <div
            class="video-card card bg-dark text-light border-dark shadow-sm mb-4"
            @click="navigateTo('TrainingSessionVideoView', video)"
          >
            <span
              v-if="video.trainingsmethode === 'laufen'"
              style="position: absolute; margin-top: 0.2rem; left: 0.2rem"
              class="badge rounded-pill text-dark bg-warning"
            >
              <TrainingsmethodeIconComponent
                trainingsmethode-id="laufen"
              ></TrainingsmethodeIconComponent>
            </span>
            <span
              v-if="video.trainingsmethode === 'fahrradfahren'"
              style="position: absolute; margin-top: 0.2rem; left: 0.2rem"
              class="badge rounded-pill text-dark bg-success"
            >
              <TrainingsmethodeIconComponent
                trainingsmethode-id="fahrradfahren"
              ></TrainingsmethodeIconComponent>
            </span>
            <span
              v-if="video.trainingsmethode === 'rudern'"
              style="position: absolute; margin-top: 0.2rem; left: 0.2rem"
              class="badge rounded-pill text-dark bg-info"
            >
              <TrainingsmethodeIconComponent
                trainingsmethode-id="rudern"
              ></TrainingsmethodeIconComponent>
            </span>

            <span
              style="position: absolute; margin-top: 0.2rem; right: 4.5rem"
              class="badge rounded-pill bg-secondary text-light"
            >
              ~{{ geschaetzteDistanz(video) }} km
            </span>

            <span
              style="position: absolute; margin-top: 0.2rem; right: 0.2rem"
              class="badge rounded-pill bg-primary"
            >
              {{ video.dauer }}
            </span>

            <img
              :src="video.thumbnail"
              class="card-img-top"
              :alt="video.titel"
            />
            <div class="card-body">
              <h5 class="video-card-title card-title" :title="video.titel">
                {{ video.titel }}
              </h5>

              <span
                v-if="video.tag"
                style="position: absolute; bottom: 0.4rem; right: 0.2rem"
                class="badge rounded-pill bg-light text-dark"
              >
                {{ video.tag }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { notify } from "@kyvg/vue3-notification";
import { addDoc, collection, doc, getDoc, getDocs } from "firebase/firestore";
import { firebaseAuth, firebaseDb } from "@/main";
import { onAuthStateChanged } from "firebase/auth";
import TrainingsmethodeIconComponent from "@/components/Shared/TrainingsmethodeIconComponent.vue";

export default {
  components: { TrainingsmethodeIconComponent },
  data() {
    return {
      benutzer: null,
      istAdmin: false,
      filterTag: null,
      filterTrainingsmethode: "rudern", // Aktueller Filter (laufen, fahrradfahren, rudern oder null)
      sortOrder: 0, // 0 = keine Sortierung, 1 = aufsteigend, -1 = absteigend
      newVideo: {
        titel: null,
        dauer: "00:00:00",
        trainingsmethode: "laufen",
        tag: null,
        url: null,
        id: null,
        baseSpeedInKmH: 3,
        thumbnail: null,
        videobeginn: "00:00:00",
      },
      videos: [],
    };
  },
  async mounted() {
    onAuthStateChanged(firebaseAuth, async (user) => {
      if (!user) {
        this.$router.push("/login");
      } else {
        await this.loadData();
      }
    });

    try {
      const userDocRef = doc(
        firebaseDb,
        "benutzer",
        firebaseAuth.currentUser.uid
      );
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        this.benutzer = userDocSnap.data();
        this.istAdmin = this.benutzer.istAdmin;
        this.filterTrainingsmethode =
          this.benutzer.defaultTrainingsmethodeFilter;
      }
    } catch (error) {
      console.error("Fehler beim Laden der Nutzerdaten:", error);
    }
  },
  computed: {
    knownTags() {
      return [...new Set(this.videos.map((video) => video.tag))];
    },
    filterTrainingsmethoden() {
      return this.filterTrainingsmethode;
    },
    filteredAndSortedVideos() {
      let result = this.videos;

      // Filter
      if (this.filterTrainingsmethode || this.filterTag) {
        result = result.filter((video) => {
          if (this.filterTrainingsmethode && !this.filterTag) {
            return video.trainingsmethode === this.filterTrainingsmethode;
          } else if (this.filterTrainingsmethode && this.filterTag) {
            return (
              video.trainingsmethode === this.filterTrainingsmethode &&
              video.tag === this.filterTag
            );
          } else {
            return video.tag === this.filterTag;
          }
        });
      }

      // Sortierung
      if (this.sortOrder !== 0) {
        result = [...result].sort((a, b) => {
          const dauerA = this.parseDauer(a.dauer);
          const dauerB = this.parseDauer(b.dauer);

          return this.sortOrder * (dauerA - dauerB);
        });
      }

      return result;
    },
  },
  methods: {
    async loadData() {
      try {
        const videoquellenSnap = await getDocs(
          collection(firebaseDb, "videoquellen")
        );
        this.videos = videoquellenSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      } catch (error) {
        console.error("Fehler beim Laden der Daten:", error);
      }
    },

    oeffneYoutubeSuche() {
      const youtubeUrl =
        "https://www.youtube.com/results?search_query=indoor+training" +
        (this.filterTag === "Training"
          ? "+workout"
          : this.filterTag === "Landschaft"
          ? "+landscape"
          : this.filterTag
          ? "+" + this.filterTag
          : "") +
        (this.filterTrainingsmethode === "fahrradfahren"
          ? "+cycling"
          : this.filterTrainingsmethode === "rudern"
          ? "+rowing"
          : this.filterTrainingsmethode === "laufen"
          ? "+running"
          : "");

      window.open(youtubeUrl, "_blank");
    },
    toggleFilter(trainingsmethode) {
      this.filterTrainingsmethode =
        this.filterTrainingsmethode === trainingsmethode
          ? null
          : trainingsmethode;
    },
    toggleSort() {
      this.sortOrder = ((this.sortOrder + 2) % 3) - 1;
    },
    parseDauer(dauer) {
      // Splitte die Zeit in Stunden, Minuten und Sekunden
      const [hours, minutes, seconds] = dauer.split(":").map(Number);

      // Berechne die Gesamtzeit in Sekunden
      return hours * 3600 + minutes * 60 + seconds;
    },
    geschaetzteDistanz(video) {
      // eslint-disable-next-line no-prototype-builtins
      if (!video || !video.hasOwnProperty("dauer")) {
        return "";
      }

      const dauerInSekunden = this.parseDauer(video.dauer);
      const distance = video.baseSpeedInKmH * (dauerInSekunden / 60 / 60);

      return (Math.round(distance * 100) / 100).toFixed(2);
    },
    getVideoIdFromUrl(url) {
      const regex =
        /(?:https?:\/\/(?:www\.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/))([^"&?/\s]{11})/;
      const match = url.match(regex);

      return match ? match[1] : null; // Gibt die Video-ID zurück oder `null`, falls keine gefunden wurde
    },
    showHinzufuegenModal() {
      const modalElement = document.getElementById("add-modal");
      const modal = new Modal(modalElement);
      modal.show();
    },
    async speichern() {
      if (
        !this.newVideo.titel ||
        !this.newVideo.dauer ||
        !this.newVideo.trainingsmethode ||
        !this.newVideo.tag ||
        !this.newVideo.url ||
        !this.newVideo.baseSpeedInKmH ||
        this.newVideo.baseSpeedInKmH <= 0 ||
        !this.newVideo.videobeginn
      ) {
        console.log("Fehlerhafte Eingabe: ", this.newVideo);

        notify({
          title: "Fehler",
          text: "Bitte fülle alle Felder aus.",
          type: "error",
          duration: 5000,
        });

        return;
      }

      const videoId = this.getVideoIdFromUrl(this.newVideo.url);

      if (!videoId) {
        notify({
          title: "Fehler",
          text: "Id kann nicht ermittelt werden. Bitte wähle ein anderes Video.",
          type: "error",
          duration: 5000,
        });

        return;
      }

      const newVideo = {
        titel: this.newVideo.titel,
        dauer: this.newVideo.dauer /* Format: HH:MM:SS */,
        trainingsmethode: this.newVideo.trainingsmethode,
        tag: this.newVideo.tag,
        url: this.newVideo.url,
        videoId: videoId,
        baseSpeedInKmH: this.newVideo.baseSpeedInKmH,
        thumbnail: `https://img.youtube.com/vi/${videoId}/0.jpg`,
        videobeginn: this.newVideo.videobeginn /* Format: HH:MM:SS */,
      };

      try {
        await addDoc(collection(firebaseDb, "videoquellen"), newVideo);

        notify({
          title: "Erfolg",
          text: "Neues Video erfolgreich gespeichert!",
          type: "success",
        });

        this.videos.push(newVideo);

        // Reset "newVideo"
        this.newVideo = {
          titel: null,
          dauer: "00:00:00",
          trainingsmethode: "laufen",
          tag: null,
          url: null,
          videoId: null,
          baseSpeedInKmH: 0,
          thumbnail: null,
          videobeginn: "00:00:00" /* Format: HH:MM:SS */,
        };

        const modalElement = document.getElementById("add-modal");
        const modal = Modal.getInstance(modalElement);
        modal.hide();
      } catch (error) {
        console.error("Fehler beim Speichern:", error);

        notify({
          title: "Fehler",
          text: "Video konnte nicht gespeichert werden.",
          type: "error",
        });
      }
    },
    navigateTo(componentName, video) {
      this.$router.push({
        name: componentName,
        params: {
          id: video.id,
          videoUrl: video.url,
          videoId: video.videoId,
          baseSpeed: video.baseSpeedInKmH,
          videobeginn: video.videobeginn,
          videodauer: video.dauer,
          videotitel: video.titel,
          trainingsmethode: video.trainingsmethode,
        },
      });
    },
  },
};
</script>

<style scoped>
/* BACKGROUND */
.background-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
    315deg,
    var(--ruderclub-orange) 3%,
    #c28019 38%,
    #087774 68%,
    var(--ruderclub-dark-green) 98%
  );
  animation: gradient 15s ease infinite;
  background-size: 400% 400%;
  background-attachment: fixed;
  z-index: -2;
}

/* Keyframes für Animation */
@keyframes gradient {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0 0;
  }
}

/* Wellen-Effekt */
.wave {
  background: rgb(255 255 255 / 25%);
  border-radius: 1000% 1000% 0 0;
  position: fixed;
  width: 200%;
  height: 12em;
  animation: wave 10s -3s linear infinite;
  transform: translate3d(0, 0, 0);
  opacity: 0.8;
  bottom: 0;
  left: 0;
  z-index: -1;
}

.wave:nth-of-type(2) {
  bottom: -1.25em;
  animation: wave 18s linear reverse infinite;
  opacity: 0.8;
}

.wave:nth-of-type(3) {
  bottom: -2.5em;
  animation: wave 20s -1s reverse infinite;
  opacity: 0.9;
}

@keyframes wave {
  2% {
    transform: translateX(1);
  }
  25% {
    transform: translateX(-25%);
  }
  50% {
    transform: translateX(-50%);
  }
  75% {
    transform: translateX(-25%);
  }
  100% {
    transform: translateX(1);
  }
}

/* HEADER */
.pills {
  position: absolute;

  @media (min-width: 768px) {
    position: relative;
  }
}

/* CARDS */
.video-card {
  cursor: pointer;
}
.video-card-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.icon-large {
  font-size: 13.7rem;
}
@media (max-width: 1199px) {
  .icon-large {
    font-size: 10rem;
  }
}
@media (max-width: 730px) {
  .icon-large {
    font-size: 16rem;
  }
}
.video-card:hover {
  transform: scale(1.01);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.btn-group button {
  height: 42px;
}
/* Outlined Badge Styles */
.badge.bg-outline-info {
  background-color: #ededed;
  color: #0dcaf0; /* Bootstrap Info Color */
  border: 1px solid #0dcaf0;
}

.badge.bg-outline-success {
  background-color: #ededed;
  color: #198754; /* Bootstrap Success Color */
  border: 1px solid #198754;
}

.badge.bg-outline-warning {
  background-color: #ededed;
  color: #ffc107; /* Bootstrap Warning Color */
  border: 1px solid #ffc107;
}

/* Optional: Hover Effect for Outlined Badges */
.badge.bg-outline-info:hover {
  background-color: #0dcaf0;
  color: #fff;
}

.badge.bg-outline-success:hover {
  background-color: #198754;
  color: #fff;
}

.badge.bg-outline-warning:hover {
  background-color: #ffc107;
  color: #212529;
}
</style>
